import { ca } from '@cian/analytics';

export const bannerCard = 'banner_card';

export function trackShowStalkerBanner(label: string) {
  ca('event', {
    name: 'oldevent',
    category: 'LoginMotivation_popup',
    action: 'show',
    label,
  });
}

export function trackCloseStalkerBanner(label: string) {
  ca('event', {
    name: 'oldevent',
    category: 'LoginMotivation_popup',
    action: 'close',
    label,
  });
}

export function trackClickLogin(label: string) {
  ca('event', {
    name: 'oldevent',
    category: 'LoginMotivation_popup',
    action: 'click_login',
    label,
  });
}
